var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiUsers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3261_13781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41002 19.6101L6.42002 19.8401C5.71002 20.0001 5.16002 20.5601 4.99002 21.2701L4.76002 22.2601C4.74002 22.3601 4.58002 22.3601 4.56002 22.2601L4.33002 21.2701C4.17002 20.5601 3.61002 20.0101 2.90002 19.8401L1.91002 19.6101C1.81002 19.5901 1.81002 19.4301 1.91002 19.4101L2.90002 19.1801C3.61002 19.0201 4.16002 18.4601 4.33002 17.7501L4.56002 16.7601C4.58002 16.6601 4.74002 16.6601 4.76002 16.7601L4.99002 17.7501C5.15002 18.4601 5.71002 19.0101 6.42002 19.1801L7.41002 19.4101C7.51002 19.4301 7.51002 19.5901 7.41002 19.6101Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16 10.87C9.06 10.86 8.94 10.86 8.83 10.87C6.45 10.79 4.56 8.84 4.56 6.44C4.56 4.04 6.54 2 9 2C11.46 2 13.44 3.99 13.44 6.44C13.43 8.84 11.54 10.79 9.16 10.87Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.41 4C18.35 4 19.91 5.57 19.91 7.5C19.91 9.43 18.41 10.93 16.54 11C16.46 10.99 16.37 10.99 16.28 11",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 21.81C10.87 21.84 12.75 21.38 14.17 20.43C16.59 18.81 16.59 16.17 14.17 14.56C12.76 13.62 10.87 13.16 9.00002 13.19C8.00002 13.21 7.01002 13.36 6.10002 13.65C5.72002 13.77 5.36002 13.91 5.02002 14.08",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.34 20C19.06 19.85 19.74 19.56 20.3 19.13C21.86 17.96 21.86 16.03 20.3 14.86C19.75 14.44 19.08 14.16 18.37 14",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3261_13781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUsers);
export default __webpack_public_path__ + "static/media/ai-users.1f3e172f90ab635a6dfb0d1a581b3846.svg";
export { ForwardRef as ReactComponent };